module.exports = __webpack_public_path__ + "static/media/Penerbit Haru.6fbef026.png";